import { create } from "zustand";
import { persist } from "zustand/middleware";

export type PanelBehavior = 0 | 1 | 2; // 0 = Never, 1 = Page Dependent, 2 = Always

/**
 * Colour theme preference. "system" follows the operating system's
 * light/dark setting (prefers-color-scheme) and is the default.
 */
export type ThemeMode = "system" | "light" | "dark";

export const DEFAULT_THEME_MODE: ThemeMode = "system";

interface SettingsStore {
  navPanelBehavior: PanelBehavior;
  toolsPanelBehavior: PanelBehavior;
  themeMode: ThemeMode;
  setNavPanelBehavior: (behavior: PanelBehavior) => void;
  setToolsPanelBehavior: (behavior: PanelBehavior) => void;
  setThemeMode: (mode: ThemeMode) => void;
}

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      navPanelBehavior: 1,
      toolsPanelBehavior: 1,
      // Users who saved settings before this field existed have no persisted
      // themeMode; persist merges stored state over these defaults, so they
      // pick up "system" too.
      themeMode: DEFAULT_THEME_MODE,
      setNavPanelBehavior: (behavior) => set({ navPanelBehavior: behavior }),
      setToolsPanelBehavior: (behavior) =>
        set({ toolsPanelBehavior: behavior }),
      setThemeMode: (mode) => set({ themeMode: mode }),
    }),
    {
      name: "fuse-bart-portal.settings",
    },
  ),
);
